import crud from './_crud'
import { callApi } from 'utils/api'
import Swal from 'sweetalert2'
import i18next from 'i18next'
const t = (key) => i18next.t(key)

const entity = 'document_item'
const entityMsg = 'Documento'

const addDocumentItem = (item, file) => {
	return async (dispatch, getState) => {
		const state = getState()

		let res = await callApi(`/${entity}/addDocumentItem/`, {
			json: false,
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				item: JSON.stringify(item),
				files: file?.content ?? file,
			},
			// successMessage: `Se agregó el documento correctamente.`,
		})

		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Se agregó el documento correctamente.'),
			icon: 'success',
			confirmButtonText: t('OK'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})

		return res.body
	}
}

const addDocumentItemSilent = (item, file) => {
	return async (dispatch, getState) => {
		const state = getState()

		let res = await callApi(`/${entity}/addDocumentItem/`, {
			json: false,
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: {
				item: JSON.stringify(item),
				files: file?.content ?? file,
			},
		})

		return res.body
	}
}

const updateDocumentItem = (item, images, file) => {
	return async (dispatch, getState) => {
		const state = getState()
		console.log(item)

		delete item.has_attachment

		let res = await callApi(`/${entity}/updateDocumentItem/${item.id}`, {
			json: false,
			method: 'POST',
			body: {
				item: JSON.stringify(item),
				images, // antigua
				files: file?.content ?? file,
			},
			headers: {
				Authorization: state.app.user.token,
			},
			// successMessage: `Se actualizó el documento correctamente.`,
		})

		let stored_item = res.body
		console.log(stored_item)

		dispatch({
			type: `UPDATE_DOCUMENT_ITEM`,
			response: stored_item,
		})

		Swal.fire({
			title: t('¡Acción Realizada!'),
			text: t('Se actualizó el documento correctamente.'),
			icon: 'success',
			confirmButtonText: t('OK'),
			showCloseButton: true,
		}).then((result) => {
			if (result.isConfirmed) {
				window.location.reload()
			}
		})

		return stored_item
	}
}

const updateDocumentItemSilent = (item, images, file) => {
	return async (dispatch, getState) => {
		const state = getState()
		const nextItem = { ...item }

		delete nextItem.has_attachment

		let res = await callApi(`/${entity}/updateDocumentItem/${nextItem.id}`, {
			json: false,
			method: 'POST',
			body: {
				item: JSON.stringify(nextItem),
				images,
				files: file?.content ?? file,
			},
			headers: {
				Authorization: state.app.user.token,
			},
		})

		let stored_item = res.body

		dispatch({
			type: `UPDATE_DOCUMENT_ITEM`,
			response: stored_item,
		})

		return stored_item
	}
}

const loadExpirationReport = () => {
	return async (dispatch, getState) => {
		const state = getState()

		// Verificar que el usuario existe antes de continuar
		if (!state.app.user || !state.app.user.token) {
			console.warn('⚠️ Usuario no autenticado, cancelando petición')
			return null
		}

		const res = await callApi(`/${entity}/utils/get_expiration_report`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `LOAD_REPORT_${entity.toUpperCase()}`,
			response: res.body,
		})

		return res.body
	}
}

const fetchDocumentsItemsByEntity =(entity, entity_id) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/document_item/fetch_documents_items_by_entity/${entity}/${entity_id}`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			}
		})

		return res.body
	}
}


let customActions = {}
customActions = {
	...customActions,
	loadExpirationReport,
	updateDocumentItem,
	updateDocumentItemSilent,
	addDocumentItem,
	addDocumentItemSilent,
}
const actions = {
	...crud(entity, 'el documento', 'los documentos'),
	...customActions,
}

export default { ...actions, fetchDocumentsItemsByEntity }
